import { render, staticRenderFns } from "./add-diy-topic.vue?vue&type=template&id=2ce9b832"
import script from "./add-diy-topic.vue?vue&type=script&lang=js"
export * from "./add-diy-topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ce9b832')) {
      api.createRecord('2ce9b832', component.options)
    } else {
      api.reload('2ce9b832', component.options)
    }
    module.hot.accept("./add-diy-topic.vue?vue&type=template&id=2ce9b832", function () {
      api.rerender('2ce9b832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/topic-list/add-diy-topic.vue"
export default component.exports